import { MessageCircle } from 'lucide-react';

const WHATSAPP_GENERAL = 'https://wa.me/5551996777625?text=Ol%C3%A1!%20Gostaria%20de%20falar%20com%20um%20especialista%20iGreen.';

const footerLinks = [
  { label: 'Energia', href: '#energia' },
  { label: 'Seguro', href: '#seguro' },
  { label: 'Telecom', href: '#telecom' },
  { label: 'Licenciado', href: '#licenciado' },
  { label: 'Depoimentos', href: '#depoimentos' },
  { label: 'Reconhecimento', href: '#reconhecimento' },
];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-background-950 border-t border-background-800/30">
      <div className="container-wide py-12 md:py-16">
        <div className="mb-10 flex flex-col items-center justify-between gap-8 text-center md:flex-row md:text-left">
          {/* Brand */}
          <a href="#inicio" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
            <img
              src={`${__BASE_PATH__}assets/igreen-logo.png`}
              alt="iGreen"
              className="h-auto w-[200px] object-contain"
            />
          </a>

          {/* Nav */}
          <nav className="flex flex-wrap items-center justify-center gap-4 md:justify-end md:gap-6">
            {footerLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => handleNav(link.href)}
                className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
              >
                {link.label}
              </button>
            ))}
            <a
              href={WHATSAPP_GENERAL}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors duration-200"
            >
              <MessageCircle className="w-4 h-4" />
              Contato
            </a>
          </nav>
        </div>

        {/* Divider */}
        <div className="h-px bg-background-800/50 mb-6" />

        {/* Legal */}
        <div className="flex flex-col items-center justify-between gap-4 text-center sm:flex-row sm:text-left">
          <p className="text-xs text-foreground-600 leading-relaxed max-w-lg">
            Site administrado por um licenciado autorizado e independente da iGreen Energy.
          </p>
          <p className="text-xs text-foreground-700 sm:text-right">
            &copy; {new Date().getFullYear()} iGreen Energy. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
